import { render, staticRenderFns } from "./frozenTransfer.vue?vue&type=template&id=171b64cf&scoped=true&"
import script from "./frozenTransfer.vue?vue&type=script&lang=js&"
export * from "./frozenTransfer.vue?vue&type=script&lang=js&"
import style0 from "./frozenTransfer.vue?vue&type=style&index=0&id=171b64cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b64cf",
  null
  
)

export default component.exports